import { type User, getUserFromPageMeta } from "./user";

const maybeSetUserIdentityInDatafast = (user: User) => {
  const { datafast } = window;

  if (!datafast) {
    return;
  }

  datafast("identify", {
    user_id: user.id,
    name: user.name,
    image: user.avatar_url,
  });
};

const maybeSetUserIdentityInCrisp = (user: User) => {
  const { $crisp } = window;

  if (!$crisp) {
    return;
  }

  if (user.email) {
    $crisp.push(["set", "user:email", [user.email]]);
  }

  if (user.name) {
    $crisp.push(["set", "user:nickname", [user.name]]);
  }

  if (user.avatar_url) {
    $crisp.push(["set", "user:avatar", [user.avatar_url]]);
  }
};

const maybeSetUserIdentity = () => {
  const user = getUserFromPageMeta();

  if (user) {
    maybeSetUserIdentityInDatafast(user);
    maybeSetUserIdentityInCrisp(user);
  }
};

let analyticsInitialized = false;

export const initAnalytics = () => {
  if (analyticsInitialized) {
    return;
  }

  analyticsInitialized = true;

  maybeSetUserIdentity();
};
